module.exports = __webpack_public_path__ + "img/sfondo-sushi.6b92c755.png";